module.exports = __webpack_public_path__ + "img/zjjh_0_black.ab037593.png";